// @flow
import React from "react";
import { withGlobalContext } from "../../../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import BackgroundSlider from "react-background-slider";

import HeaderSearch from "../HeaderSearch";

import type { $Agent, $Site, $SiteOffice, $Team } from "flow/types";

type $Props = {
  agent: $Agent,
  classes: Object,
  site: $Site,
  office: $SiteOffice,
  team: $Team,
  backgroundImage: string,
  backgroundImages?: Array<string>,
  isCanadian: Function,
};

const StackedNameSearch = (props: $Props) => {
  const renderImage = () => {
    const { agent, classes, site, team, office } = props;
    let imagePath;

    if (site.userId && agent) {
      imagePath = `${agent.picture}?crop=faces&fit=crop&w=150&h=150`;
    } else if (site.teamId && team) {
      imagePath = team.logoPath;
    } else if (site.officeId && office) {
      imagePath = office.logo;
    } else {
      imagePath = "";
    }

    return <img className={classes.agentImage} src={imagePath} alt="" />;
  };

  const renderHeadline = () => {
    const { agent, site, team, office } = props;
    if (site.userId && agent) {
      return agent.fullName;
    } else if (site.teamId && team) {
      return team.name;
    } else if (site.officeId && office) {
      return office.name;
    } else {
      return "";
    }
  };

  const { classes, backgroundImage, backgroundImages, isCanadian } = props;

  if (backgroundImages && backgroundImages.length > 1) {
    return (
      <div className={classes.rootImages}>
        <BackgroundSlider
          images={backgroundImages}
          duration={5}
          transition={2}
        />
        <div className={classes.backgroundImagesOverlay}>
          {renderImage()}
          <Typography
            type="heading3"
            color="#ffffff"
            style={{ textAlign: "center" }}
          >
            {renderHeadline()}
          </Typography>
          <div className={classes.searchBar}>
            <HeaderSearch showColorButtons={false} isCanadian={isCanadian()} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={classes.root}
      style={{
        background: `linear-gradient(rgba(20, 20, 20, 0.4), rgba(20, 20, 20, 0.4)), url(${backgroundImage}) center/cover no-repeat`,
      }}
    >
      {renderImage()}
      <Typography
        type="heading3"
        color="#ffffff"
        style={{ textAlign: "center" }}
      >
        {renderHeadline()}
      </Typography>
      <div className={classes.searchBar}>
        <HeaderSearch showColorButtons={false} isCanadian={isCanadian()} />
      </div>
    </div>
  );
};

const styles = (theme) => ({
  root: {
    display: "flex",
    position: "relative",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "52px 0",
  },
  rootImages: {
    display: "flex",
    position: "relative",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "0px 0",
  },
  backgroundImagesOverlay: {
    backgroundColor: "#00000050",
    width: "100%",
    display: "flex",
    position: "relative",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "52px 0",
  },
  agentImage: {
    display: "block",
    width: "150px",
    height: "150px",
    borderRadius: "50%",
  },
  searchBar: {
    position: "relative",
    width: "100%",
    maxWidth: "500px",
    padding: "0 24px",
    zIndex: theme.zIndex.dropdown,
  },
});

export default withGlobalContext(withStyles(styles)(StackedNameSearch));
